<script>
import baseMixin from '@mixins/baseMixin'
import BaseButton from '@/components/_base-button.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NavDrawerSignoutButton',
  components: {
    BaseButton,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
    signOutButtonClasses() {
      return {
        'justify-end align-right': this.isMobileViewPort,
        'pa-4 hover-bg-color sign-out-btn':
          !this.isMobileViewPort && !this.mini,
        'align-self-center': !this.isMobileViewPort && !this.mini,
      }
    },
    iconStyle() {
      if (!this.isMobileViewPort) return {}
      return {
        marginRight: this.mini ? '' : '20px',
      }
    },
  },
  methods: {
    ...mapActions({
      logOut: 'auth/logOut',
    }),
    handleSignOut() {
      this.logOut({ redirect: true, nuke: true })
    },
  },
}
</script>

<template>
  <v-tooltip right>
    <template v-slot:activator="{ on }">
      <BaseButton
        :class="signOutButtonClasses"
        :width="isMobileViewPort ? '20%' : '28'"
        :height="isMobileViewPort ? '48' : '28'"
        color="white"
        hover-color="blue400"
        :border-radius="'8px'"
        data-cy="sign-out-btn"
        @click="handleSignOut"
        v-on="on"
      >
        <v-icon :size="isMobileViewPort ? 20 : undefined" :style="iconStyle">
          mdi-logout
        </v-icon>
      </BaseButton>
    </template>
    <span v-text="$t('layout.logout')"></span>
  </v-tooltip>
</template>

<style lang="scss" scoped>
@import '@styles';
@import '@/styles/nav-drawer.scss';
</style>
